import { TextHeader } from './TextHeader';

type Props = {
  title: string;
  count?: number;
};

export const TableHeader = (props: Props) => {
  return (
    <TextHeader
      mb={0}
      tagLevel="h3"
      title={props.count ? `${props.title} (${props.count})` : props.title}
    />
  );
};
